import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getChangeLogs } from '@features/changeLogs/services/changeLogService';

const BASE = 'changeLogs';

const changeLogsQueryKeys = {
    base: () => [BASE],
    list: (filters) => filters ? [BASE, 'list', filters] : [BASE, 'list'],
}

export const useGetChangeLogs = (filters) => {
    return useQuery({
        queryKey: changeLogsQueryKeys.list(filters),
        placeholderData: keepPreviousData,
        queryFn: () => getChangeLogs(filters),
    });
};